import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import { useAtom } from 'jotai';
import React, { useEffect, useRef } from 'react';
import { View } from 'react-native';
import styled from 'styled-components/native';
import { color } from '@/constant/color.ts';
import { searchQueryAtom, viewStateAtom, } from '@/screens/SearchScreen/atoms';
import SearchCategory from '@/screens/SearchScreen/components/SearchHeader/SearchCategory.tsx';
import SearchFilterPreview from '@/screens/SearchScreen/components/SearchHeader/SearchFilterPreview.tsx';
import SearchInputText from '@/screens/SearchScreen/components/SearchHeader/SearchInputText.tsx';
export default function SearchHeader({ onQueryUpdate, autoFocus, onBack, }) {
    const [viewState] = useAtom(viewStateAtom);
    const [searchQuery] = useAtom(searchQueryAtom);
    const hasBeenMapRef = useRef(false);
    useEffect(() => {
        if (!viewState.inputMode) {
            hasBeenMapRef.current = true;
        }
    }, [viewState.inputMode]);
    return (_jsxs(Container, { children: [_jsx(SearchInputText, { onTextUpdate: (keyword, isPreviewChange) => {
                    onQueryUpdate({ text: keyword }, {
                        shouldRecordHistory: !isPreviewChange,
                        shouldRemainInInputMode: isPreviewChange,
                        shouldAnimate: true,
                        mode: 'place',
                    });
                }, autoFocus: autoFocus, onBack: onBack }), !searchQuery.text ? (_jsx(View, { style: { paddingBottom: 8, paddingHorizontal: 12 }, children: _jsx(SearchCategory, { onPressKeyword: (keyword, mode) => onQueryUpdate({ text: keyword, useCameraRegion: viewState.type === 'map' }, {
                        shouldRecordHistory: false,
                        shouldAnimate: !hasBeenMapRef.current,
                        mode,
                    }) }) })) : (!viewState.inputMode && _jsx(SearchFilterPreview, {}))] }));
}
const Container = styled.View `
  overflow: hidden;
  width: 100%;
  z-index: 99;
  top: 0;
  background-color: ${color.white};
  flex-direction: column;
  padding-top: 6px;
`;
